const BackToTopButton = () => (
  <div className="has-text-right is-size-7">
    <a href="#top">↑ Back to top</a>
  </div>
)

export default BackToTopButton
